import { deleteDoc, doc } from "@firebase/firestore"
import { showErrorSnackbar, showSuccessSnackbar } from "../../../shared/snackbar/snackbar-slice";
import { hideLoading, showLoading } from "./item-categories-delete-slice";
import { deleteCategories } from "../item-categories-list/item-categories-list-slice";

// export const getItemCategoriesDataService = async (dispatch, db, coll, id) => {
//     try {
//         const docRef = doc(db, coll, id);
//         const docSnap = await getDoc(docRef);
//         if (docSnap.exists()) {
//             return docSnap.data();
//         } else {
//             dispatch(showWarningSnackbar("This document no longer exists."));
//         }
//     } catch(e) {
//         console.error("ItemCategoriesDelete getItemCategoriesDataService error: ", e);
//     }
// };

export const deleteItemCategoriesService = async (dispatch, db, coll, id) => {
    dispatch(showLoading());
    try {
        await deleteDoc(doc(db, coll, id));
        dispatch(deleteCategories(id));
        dispatch(showSuccessSnackbar('Deleted successfully!'));
    } catch(e) {
        dispatch(showErrorSnackbar('Delete failed! Please, try again.'));
        console.error("ItemCategoriesDelete deleteItemCategoriesService error: ", e);
    }
    dispatch(hideLoading());
};